import { connect } from "react-redux";
import WhatMovedMost from "./WhatMovedMost";


const mapStateToProps = (state) => ({
    fetchTrendSelfVsOthersApi: state.BenchmarkFilteringReducer.fetchTrendSelfVsOthersApi,
    scaleType: state.BenchmarkFilteringReducer.scaleType,

});

const mapDispatchToProps = (dispatch) => ({

});


export default connect(mapStateToProps, mapDispatchToProps)(WhatMovedMost);
